import React from 'react'
import './style.css'
import { Heart } from '../icons/Heart'

export const Calendar = () => {
    return (

        <div className='Calendar'>
            <div className='Calendar__item'>
                <div className='Calendar__item_header'>Август</div>
                <div className="Calendar__days">
                    <div className="Calendar__weeks">Пн</div>
                    <div className="Calendar__weeks">Вт</div>
                    <div className="Calendar__weeks">Ср</div>
                    <div className="Calendar__weeks">Чт</div>
                    <div className="Calendar__weeks">Пт</div>
                    <div className="Calendar__weeks Calendar__weeks_holiday">Сб</div>
                    <div className="Calendar__weeks Calendar__weeks_holiday">Вс</div>
                    <div className="calender_day"></div>
                    <div className="calender_day"></div>
                    <div className="calender_day"></div>
                    <div className="calender_day"></div>
                    <div className="calender_day"></div>
                    <div className="Calendar__day Calendar__day_holiday">1</div>
                    <div className="Calendar__day Calendar__day_holiday">2</div>
                    <div className="Calendar__day">3</div>
                    <div className="Calendar__day">4</div>
                    <div className="Calendar__day">5</div>
                    <div className="Calendar__day Calendar__day_heart">
                        <Heart className={'Calendar__heart'} />
                        <div>6</div>
                    </div>
                    <div className="Calendar__day">7</div>
                    <div className="Calendar__day Calendar__day_holiday">8</div>
                    <div className="Calendar__day Calendar__day_holiday">9</div>
                    <div className="Calendar__day">10</div>
                    <div className="Calendar__day">11</div>
                    <div className="Calendar__day">12</div>
                    <div className="Calendar__day">13</div>
                    <div className="Calendar__day">14</div>
                    <div className="Calendar__day Calendar__day_holiday">15</div>
                    <div className="Calendar__day Calendar__day_holiday">16</div>
                    <div className="Calendar__day">17</div>
                    <div className="Calendar__day">18</div>
                    <div className="Calendar__day">19</div>
                    <div className="Calendar__day">20</div>
                    <div className="Calendar__day">21</div>
                    <div className="Calendar__day Calendar__day_holiday">22</div>
                    <div className="Calendar__day Calendar__day_holiday">23</div>
                    <div className="Calendar__day">24</div>
                    <div className="Calendar__day">25</div>
                    <div className="Calendar__day">26</div>
                    <div className="Calendar__day">27</div>
                    <div className="Calendar__day">28</div>
                    <div className="Calendar__day Calendar__day_holiday">29</div>
                    <div className="Calendar__day Calendar__day_holiday">30</div>
                    <div className="Calendar__day">31</div>
                    <div className="calender_day"></div>
                    <div className="calender_day"></div>
                    <div className="calender_day">
                    </div>
                    <div className="calender_day">
                    </div>
                </div>
            </div>
        </div>
    )
}
